import React from "react";

/* eslint-disable react/prop-types */

export default function VisualTextElement({ element, onActions }) {
  const { content = "", image, imagePosition = "top", buttons = [] } = element;

  const hasImage = !!image;
  const isAside = imagePosition === "aside-left" || imagePosition === "aside-right";

  return (
    <div className={`sce-visualtext sce-visualtext--img-${imagePosition}`}>
      {hasImage && (isAside || imagePosition === "top") && (
        <div className={`sce-visualtext__img-wrap sce-visualtext__img-wrap--${imagePosition}`}>
          <img src={image} alt="" className="sce-visualtext__img" />
        </div>
      )}

      {content && <p className="sce-visualtext__content">{content}</p>}

      {hasImage && imagePosition === "bottom" && (
        <div className="sce-visualtext__img-wrap sce-visualtext__img-wrap--bottom">
          <img src={image} alt="" className="sce-visualtext__img" />
        </div>
      )}

      {buttons.length > 0 && (
        <div className="sce-visualtext__buttons">
          {buttons.map((btn) => (
            <button
              key={btn.id}
              type="button"
              className={`sce-btn sce-btn--${btn.style || "primary"}`}
              onClick={() => onActions(btn.actions || [])}
            >
              {btn.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
